/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import qs from 'qs';
import store from '@/store';
// import store from '../stores';
import { objectIsEmpty } from '../utils/index'
// import store from '../stores/index'
// import  apiConfig  from '../config/apiConfig'

// 环境的切换
let baseURL = 'https://mobile.aigupiao.com';
if (process.env.NODE_ENV === 'development') {
    baseURL = '/'
} else if (process.env.NODE_ENV === 'production' && false) {
    baseURL = '';
}
console.log(process.env.NODE_ENV, "process.env.NODE_ENV ")


const axiosM = axios.create({
    baseURL,
    timeout: 10 * 1000, // 请求超时时间
    withCredentials: true, // Check cross-site Access-Control
})


// post请求头
axiosM.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axiosM.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
axiosM.defaults.headers.post['Access-Control-Allow-Headers'] = '*'


// 请求拦截器
axiosM.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        let localToken = localStorage['Authorization'];
        config.headers['Authorization'] = (store&&store.state&&store.state.user&&store.state.user.user_app_token ? 'Bearer '+store.state.user.user_app_token : '') || (localToken? "Bearer " + localToken: localToken);
        return config;
    }, error => {
        return Promise.error(error);
    })

// 响应拦截器
axiosM.interceptors.response.use(response => {
    if (response.status === 200) {
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
},
    // 服务器状态码不是200的情况 
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录    
                // 未登录则跳转登录页面，并携带当前页面的路径    
                // 在登录成功后返回当前页面，这一步需要在登录页操作。    
                case 401:
                    // router.replace({
                    // 	path: '/login',
                    // 	query: {
                    // 		redirect: router.currentRoute.fullPath
                    // 	}
                    // });
                    break;
                // 403 token过期    
                // 登录过期对用户进行提示    
                // 清除本地token和清空vuex中token对象    
                // 跳转登录页面    
                case 403:
                    // Toast({
                    // 	message: '登录过期，请重新登录',
                    // 	duration: 1000,
                    // 	forbidClick: true
                    // });
                    // 清除token     
                    localStorage.removeItem('token');
                    // store.commit('loginSuccess', null);
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    // setTimeout(() => {
                    // 	router.replace({
                    // 		path: '/login',
                    // 		query: {
                    // 			redirect: router.currentRoute.fullPath
                    // 		}
                    // 	});
                    // }, 1000);
                    break;
                // 404请求不存在    
                case 404:
                    // Toast({
                    // 	message: '网络请求不存在',
                    // 	duration: 1500,
                    // 	forbidClick: true
                    // });
                    break;
                // 其他错误，直接抛出错误提示    
                default:
                // Toast({
                // 	message: error.response.data.message,
                // 	duration: 1500,
                // 	forbidClick: true
                // });
            }
            return Promise.reject(error.response);
        }
    })

/** 
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get = ({ url, params }) => {
    return new Promise((resolve, reject) => {
        axiosM.get(url, {
            params: { 'Agp-Super-Project': '1', ...params }
        }).then(res => {
            // console.log(res,"axiosM data")
            var data = {}
            data.data = res.data.data
            if (objectIsEmpty(res.data.share)) {
                // console(1111,res.data)
                resolve(res.data);
            } else if (~url.indexOf('/H5ReactUserCenter/add_stock') || ~url.indexOf('/H5ReactUserCenter/del_stock') ||
            ~url.indexOf('/calf/')) {
                resolve(res.data);
            } else {
                // console.log(22222,res.data.data)
                resolve(res.data.data);
            }
        }).catch(err => {
            reject(err.data)
        })
    });
}
/** 
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const post = ({ url, params }) => {
    return new Promise((resolve, reject) => {
        //QS.stringify(params)
        axiosM.post(url, params).then(res => {
            resolve(res.data);
        }).
            catch(err => {
                reject(err.data)
            })
    });
}

export function postForm({url, data, params}) {
    return new Promise((resolve, reject) => {
    axiosM({
        method: "post",
        url: url,
        params: params,
        data: qs.stringify(data),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

export const httpGet = ({ url, params }) => {
  return new Promise((resolve, reject) => {
      axiosM.get(url, {
          params: { 'Agp-Super-Project': '1', ...params },
      }).then(res => {
          resolve(res.data);
      }).catch(err => {
          reject(err.data)
      })
  });
}